import { Vector3 } from "three";
import { Context } from "../../../context";

import { CameraModeOptions, ControllerStrategy } from "../strategy";
import { CameraLandmark, CameraLandmarkLookup } from "../../controller";

/**
 * Map controls mean clicking and dragging upwards on the scene moves you
 * forwards on the ground plane
 */
export class MapControllerStrategy extends ControllerStrategy {
  init(context: Context, options: CameraModeOptions): ControllerStrategy {
    super.init(context);

    const controls = this.registered?.controls;
    if (controls) {
      controls.verticalDragToForward = true;

      const target = new Vector3();
      const position = new Vector3();
      controls.getTarget(target);
      controls.getPosition(position);

      const mapPlaneHeight = CameraLandmarkLookup[CameraLandmark.INIT_TARGET].y;
      if (Math.abs(target.y - mapPlaneHeight) > 0.1) {
        // target.add(position).divideScalar(2);
        controls.setLookAt(
          position.x,
          position.y,
          position.z,
          target.x,
          mapPlaneHeight,
          target.z,
          true
        );
      }
    }

    if (options?.landmark && this.registered) {
      this.registered.setLocation(options.landmark);
    }

    return this;
  }

  teardown() {
    if (this.registered?.controls) {
      this.registered.controls.verticalDragToForward = false;
    }
    super.teardown();
  }
}
